import {
    SET_REGION
} from './RegionType';


const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_REGION:
            return {
                ...state,
                regionDropDownList: action.regionDropDownList,
            };
        default:
            return state;
    }
}

export {
    reducers
}